import {
  addFavoriteChat,
  listFavoriteChats,
  removeFavoriteChat,
} from '../service/Favorites';
import { toIsoUtc } from './serverTime';

const STORAGE_KEY = 'glkbConversationBookmarks';

const normalizeSession = (session) => {
    if (!session) return null;
    const hid = session.hid ?? session.id;
    const messages = Array.isArray(session.messages) ? session.messages : [];
    return {
        id: String(hid ?? ''),
        hid: hid ?? null,
        title: session.leading_title || session.title || 'New Chat',
        leadingTitle: session.leading_title || session.title || 'New Chat',
        createdAt: toIsoUtc(session.created_at || session.createdAt),
        updatedAt: toIsoUtc(session.last_accessed_time || session.updatedAt),
        messageCount: session.message_count ?? messages.length,
        mode: session.mode || null,
        messages,
    };
};

const normalizeSessionList = (payload) => {
    const list = Array.isArray(payload?.sessions)
        ? payload.sessions
        : (Array.isArray(payload) ? payload : []);
    return list.map(normalizeSession).filter(Boolean);
};

export const getConversationBookmarks = () => {
    if (typeof window === 'undefined') return [];
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
};

export const setConversationBookmarks = (bookmarks) => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(bookmarks));
    window.dispatchEvent(new CustomEvent('glkb-conversation-bookmarks-updated', { detail: bookmarks }));
};

export const fetchConversationBookmarks = async () => {
    const data = await listFavoriteChats();
    const normalized = normalizeSessionList(data);
    setConversationBookmarks(normalized);
    return normalized;
};

export const toggleConversationBookmark = async (entry) => {
    if (!entry || (!entry.id && !entry.hid)) return getConversationBookmarks();
    const bookmarks = getConversationBookmarks();
    const hid = String(entry.hid ?? entry.id ?? '').trim();
    if (!hid) return bookmarks;
    const index = bookmarks.findIndex((item) => String(item.id) === hid || String(item.hid) === hid);

    let next = [];

    if (index >= 0) {
        await removeFavoriteChat(hid);
        next = bookmarks.filter((item) => String(item.id) !== hid && String(item.hid) !== hid);
    } else {
        await addFavoriteChat(Number(hid));
        const normalized = normalizeSession({
            hid: Number(hid),
            leading_title: entry.title || entry.leadingTitle || 'New Chat',
            last_accessed_time: entry.updatedAt || new Date().toISOString(),
            message_count: entry.messageCount ?? 0,
            mode: entry.mode || null,
        });
        next = [normalized, ...bookmarks.filter((item) => String(item.id) !== normalized.id)];
    }

    setConversationBookmarks(next);
    return next;
};
